import axios from "axios";
axios.defaults.withCredentials = true;
const instance = axios.create();

instance.interceptors.request.use(
  function (config) {
    return config;
  },
);

instance.interceptors.response.use(
  function (response) {
    return response;
  },
  function (err) {
    return Promise.reject(err);
  }
);

export default instance;
